var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.carregado
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "10px",
                "font-size": "14px",
                display: "flex",
                gap: "5px",
                "flex-wrap": "wrap",
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "label label-sm",
                  staticStyle: {
                    "background-color": "#1BBC9B !important",
                    padding: "4px 6px",
                    "border-radius": "4px",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-wrench" }),
                  _vm._v(" Tarefa\n            "),
                  _c(
                    "button",
                    {
                      staticClass: "botaoAdicionar",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.InserirRegistro(8)
                        },
                      },
                    },
                    [_vm._v("\n                +\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "label label-sm",
                  staticStyle: {
                    "background-color": "#87CEFA !important",
                    padding: "4px 6px",
                    "border-radius": "4px",
                    border: "1px solid white",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-cube" }),
                  _vm._v(" Comprado\n            "),
                  _c(
                    "button",
                    {
                      staticClass: "botaoAdicionar",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.InserirRegistro(4)
                        },
                      },
                    },
                    [_vm._v("\n                +\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "label label-sm",
                  staticStyle: {
                    "background-color": "#FFA500 !important",
                    padding: "4px 6px",
                    "border-radius": "4px",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-cubes" }),
                  _vm._v(" Manufaturado\n            "),
                  _c(
                    "button",
                    {
                      staticClass: "botaoAdicionar",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.InserirRegistro(1)
                        },
                      },
                    },
                    [_vm._v("\n                +\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "label label-sm",
                  staticStyle: {
                    "background-color": "#DAA520 !important",
                    padding: "4px 6px",
                    "border-radius": "4px",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-industry" }),
                  _vm._v(" Industria\n            "),
                  _c(
                    "button",
                    {
                      staticClass: "botaoAdicionar",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.InserirRegistro(9)
                        },
                      },
                    },
                    [_vm._v("\n                +\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "label label-sm",
                  staticStyle: {
                    "background-color": "#4682B4 !important",
                    padding: "4px 6px",
                    "border-radius": "4px",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-cogs" }),
                  _vm._v(" Serviço\n            "),
                  _c(
                    "button",
                    {
                      staticClass: "botaoAdicionar",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.InserirRegistro(3)
                        },
                      },
                    },
                    [_vm._v("\n                +\n            ")]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "DxTreeList",
            {
              ref: "gridTreeList",
              attrs: {
                id: "gridTreeList",
                "data-source": _vm.Dados,
                "column-auto-width": true,
                "word-wrap-enabled": true,
                "show-row-lines": true,
                "show-borders": true,
                "expanded-row-keys": _vm.expandedRowKeys,
                "key-expr": "Key",
                "parent-id-expr": "ProdutoPai",
              },
              on: { "selection-changed": _vm.onRowSelected },
              scopedSlots: _vm._u(
                [
                  {
                    key: "iconCell",
                    fn: function (ref) {
                      var data = ref.data
                      return [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(data.data.Icon) },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                2056051461
              ),
            },
            [
              _c("DxSearchPanel", {
                attrs: {
                  visible: true,
                  width: 280,
                  placeholder: "Pesquisar...",
                },
              }),
              _vm._v(" "),
              _c("DxSelection", { attrs: { mode: "single" } }),
              _vm._v(" "),
              _c("DxSorting", { attrs: { mode: "multiple" } }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "min-width": 400,
                  "data-field": "Nome",
                  caption: "Nome",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "min-width": 50,
                  "data-field": "Icon",
                  caption: "Tipo",
                  "cell-template": "iconCell",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "min-width": 80,
                  "data-field": "Posicao",
                  caption: "Posição",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  "min-width": 80,
                  "data-field": "Serie",
                  caption: "Série",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }